import React, { createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const META_PIXEL_ID = '962279486187488';
let initialized = false;
export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return;
  try {
    const f = window;
    const b = document;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      if (n.callMethod) {
        n.callMethod.apply(n, args);
      } else {
        n.queue.push(args);
      }
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    // Safe insertion — find a parent to append to
    const target = b.head || b.getElementsByTagName('head')[0] || b.documentElement;
    if (target) {
      target.appendChild(t);
    }
    window.fbq('init', META_PIXEL_ID);
    initialized = true;
  } catch (e) {
    console.warn('Meta Pixel initialization failed:', e);
  }
}
export function trackPageView() {
  try {
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  } catch (e) {
    console.warn('Meta Pixel PageView tracking failed:', e);
  }
}
export function trackAddToCart() {
  try {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Manual de Digestión Ligera + 3 Bonos',
        content_type: 'product',
        value: 17.0,
        currency: 'USD'
      });
    }
  } catch (e) {
    console.warn('Meta Pixel AddToCart tracking failed:', e);
  }
}